import { useEffect, useState, useRef } from "react";
import { ArrowRight } from "lucide-react";

import { CourseData } from "../../components/CourseDesc/CourseData";
import CardsForCourse from "../../components/CourseDesc/CardsForCourse";
import { baseURL } from "@/utility/api";
import { MainContext } from "@/context/MainContext";
import axios from "axios";
import { useContext } from "react";

const CourseCardPage = () => {
  const [isVisible, setIsVisible] = useState(false);
  const cardsRef = useRef(null);
  const [data, setData] = useState([]);
  const { user } = useContext(MainContext);
  const [purchaseStatusMap, setPurchaseStatusMap] = useState({});

  useEffect(() => {
    setIsVisible(true);

    async function fetchData() {
      const response = await axios.get(`${baseURL}/courses/get-all-courses`);
      setData(response.data);
    }
    fetchData();
  }, []);

  useEffect(() => {
    if (user && data.length > 0) {
      const allPurchaseStatus = async () => {
        try {
          const courseIds = data.map((course) => course.id);
          const validCourseIds = courseIds.filter(
            (id) => id !== null && id !== undefined
          );
          if (validCourseIds.length === 0) return;
          const response = await axios.get(
            `${baseURL}/courses/has-purchased-bulk`,
            {
              params: {
                ids: courseIds.join(","),
              },
              withCredentials: true,
            }
          );

          setPurchaseStatusMap(response.data);
        } catch (error) {
          console.error("Error fetching purchase status:", error);
        }
      };
      allPurchaseStatus();
    }
  }, [user, data.length]);

  // console.log("purchaseStatusMap", purchaseStatusMap);
  // console.log("allcourses", data);

  // console.log("details", data);

  const scrollToCards = () => {
    if (cardsRef.current) {
      // Changed from "center" to "start" to scroll to the top of the cards section
      cardsRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <div className="min-h-screen bg-[linear-gradient(to_bottom,rgba(0,0,0,0)_0%,rgba(0,0,0,0.8)_100%)] py-24 px-4 sm:px-6 lg:px-8">
      {/* Header */}
      <div className="max-w-7xl mx-auto mb-16">
        <h1 className="text-3xl md:text-5xl max-w-full font-bold text-white mb-4 tracking-tight">
          Build Your Future with Our{" "}
          <span className="text-[#a78bfa]">Career-Focused Courses</span>
        </h1>
        <p className="text-md md:text-xl text-gray-300 max-w-full leading-relaxed mb-8">
          Whether you're aiming to land your first internship, crack top placement offers, or level up your overall career—our
career-focused courses are designed to help you do just that. Learn how to write cold emails that get replies, create
resumes that stand out, prep for interviews like a pro, and much more. With new courses launching soon, there’s
something for every student ready to take control of their journey. Actionable. Affordable. Built for
you
        </p>
      </div>

      {/* Cards Container */}
      <div className="max-w-7xl mx-auto" ref={cardsRef}>
        <div
          className={`grid md:grid-cols-2 gap-8 transition-all duration-1000 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
          } ${
            CourseData.length % 2 !== 0
              ? "md:[&>*:last-child]:col-start-1 md:[&>*:last-child]:col-end-3 md:[&>*:last-child]:justify-self-center md:[&>*:last-child]:w-[calc(50%-1rem)]"
              : ""
          }`}
        >
          {CourseData.map((course, index) => (
            <CardsForCourse
              key={course.id}
              courses={course}
              data={data?.find((small) => small.id === course.id)}
              purchaseStatus={
                purchaseStatusMap[course.id] || {
                  hasPurchased: false,
                  isFirstTime: true,
                }
              }
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default CourseCardPage;
